module.exports = __webpack_public_path__ + "img/icon-hangout.60784e0d.svg";